/**
 * /whatsapp/* — router-shell do modulo WhatsApp (ADR-0034).
 *
 * Sub-rotas:
 *   /whatsapp/inbox (default) -> Lista de conversas + chat split-view
 *   /whatsapp/inbox/:conversaId -> mesma tela com conversa selecionada
 *   /whatsapp/instancias -> Lista de instancias WA
 *   /whatsapp/instancias/:instanciaId -> Detalhe (kill switch, QR, desconectar)
 *   /whatsapp/agendamentos -> Lista de mensagens SCHEDULED
 *   /whatsapp/configuracoes -> Singleton ConfiguracaoWhatsapp por unidade
 */
import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import InboxLista from "./Inbox/Lista";
import InstanciasLista from "./Instancias/Lista";
import InstanciaDetalhe from "./Instancias/Detalhe";
import AgendamentosLista from "./Agendamentos/Lista";
import ConfiguracoesPage from "./Configuracoes";

export default function Whatsapp() {
  return (
    <Routes>
      <Route index element={<Navigate to="inbox" replace />} />
      <Route path="inbox" element={<InboxLista />} />
      <Route path="inbox/:conversaId" element={<InboxLista />} />
      <Route path="instancias" element={<InstanciasLista />} />
      <Route path="instancias/:instanciaId" element={<InstanciaDetalhe />} />
      <Route path="agendamentos" element={<AgendamentosLista />} />
      <Route path="configuracoes" element={<ConfiguracoesPage />} />
      <Route path="*" element={<Navigate to="inbox" replace />} />
    </Routes>
  );
}
